export default __webpack_public_path__ + "static/media/bday3.80e8831c.jpg";